import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

export function EmptyPage() {
  const navigate = useNavigate()
  return (
    <div
      className='column column-center'
      style={{
        justifyContent: 'center',
        height: '100vh'
      }}
    >
      <div
        style={{
          width: 760,
          border: '1px solid #DBDBE6',
          borderRadius: '16px',
          background: '#fff'
        }}
        className='row row-center'
      >
        <div
          className='column'
          style={{
            padding: 40,
            alignItems: 'flex-start'
          }}
        >
          <p
            style={{
              fontWeight: 600,
              fontSize: 20,
              lineHeight: '130%',
              marginBottom: 16
            }}
          >
            Stay Ahead of Cyber Threats
          </p>
          <p
            style={{
              marginBottom: 32
            }}
          >
            Install the reporting button to let employees report suspicious emails with one click. Cyberlift collects
            all reports, helping your team detect phishing attempts faster and strengthen security awareness across the
            organization.
          </p>
          <Button
            onClick={() => navigate('/settings/plugins')}
            variant='contained'
            style={{
              background: '#0246F8',
              textTransform: 'none',
              width: 210,
              borderRadius: 12,
              fontFamily: 'Plus Jakarta Sans'
            }}
          >
            Install Reporting Button
          </Button>
        </div>
        <img src='images/threats-empty-page-img.png' style={{ width: 360 }} alt='' />
      </div>
    </div>
  )
}
